import { createFileRoute, Outlet } from '@tanstack/react-router'
import { DirectoryDnd } from '@/modules/file-manager/components/directory-dnd'
import { AppSidebar } from '@/routes/-components/app-sidebar/app-sidebar'

export const Route = createFileRoute('/(private)/(shell)')({
	component: ShellLayout
})

// Every private page that navigates the drive, under the sidebar. A page that
// takes the whole window lives beside this group, not inside it.
function ShellLayout() {
	return (
		// Around the sidebar and the page both, so a drag started in one can
		// land in the other (`directory-dnd.tsx`).
		<DirectoryDnd>
			<AppSidebar>
				<Outlet />
			</AppSidebar>
		</DirectoryDnd>
	)
}
